import './style.scss';
import { Box } from "@mui/material";
import AppBar from "../../components/AppBar";
import Content from "../../components/Content";
import NavigationContextProvider from "../../contexts/NavigationContext";
import PartnerPmsContextProvider from '../../contexts/PartnerPmsContext';
import ReportPreviewContextProvider from '../../contexts/ReportPreviewContext';
import ServiceOrderContextProvider from '../../contexts/ServiceOrderContext';

const Admin = () => {
    return (
        <>
            <NavigationContextProvider>
                <Box component="div" className="grid-admin">
                    <AppBar />
                    
                    <ServiceOrderContextProvider>
                        <PartnerPmsContextProvider>
                            <ReportPreviewContextProvider>
                                <Content />
                            </ReportPreviewContextProvider>
                        </PartnerPmsContextProvider>
                    </ServiceOrderContextProvider>
                </Box>
            </NavigationContextProvider>
        </>
    );
}


export default Admin;